import { SmIcon } from '@smiles/smiles-react-design-system';
import React, { useMemo } from 'react';
import { Tab } from './components';
import { generateTabLabels } from './utils';

import type { ItineraryData, TabTypes } from '../../types';

export interface IHeaderTabbedProps {
  label: string;
  type: 'dates' | 'time';
  selectedData: ItineraryData;
  activeTab?: TabTypes;
  onIconClick: () => void;
  onTabClick?: (tabType: TabTypes) => void;
}

export const HeaderTabbed = ({
  label,
  type,
  selectedData,
  activeTab,
  onIconClick,
  onTabClick,
  ...props
}: IHeaderTabbedProps) => {
  const handleTabClick = (tabType: TabTypes) => {
    if (onTabClick) {
      onTabClick(tabType);
    }
  };

  const tabLabels = useMemo(() => {
    const labels = generateTabLabels(selectedData, type);
    return Object.entries(labels) as [TabTypes, string][];
  }, [selectedData]);

  return (
    <section className="car-search-mobile-header-tabbed" {...props}>
      <article className="car-search-mobile-header-tabbed-label-wrapper">
        <label className="car-search-mobile-header-tabbed-label">{label}</label>

        <button className="car-search-mobile-header-tabbed-close-button" type="button" onClick={onIconClick}>
          <SmIcon className="car-search-mobile-header-tabbed-close-button-icon" name="close" type="round" />
        </button>
      </article>

      <article className="car-search-mobile-header-tabbed-tabs-wrapper">
        {tabLabels.map(([tabType, tabLabel]) => (
          <Tab
            key={`car-search-mobile-header-${type}-tab-${tabType}`}
            isActive={activeTab === tabType}
            type={tabType}
            label={tabLabel}
            onTabClick={handleTabClick}
          />
        ))}
      </article>
    </section>
  );
};
